import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";
import { HeaderGroup, Row } from "react-table";

import { CaseListDirection, QueueEnum } from "shared/reducers/casesReducer";

import Table from "components/admin/table/Table";

import { getDefaultCaseListSortDirection } from "./CaseList";
import TableRow from "../ViewerListsTableView/TableRow";

type CasesTableViewProps = {
  headerGroups: HeaderGroup<any>[];
  rows: Row<any>[];
  prepareRow: Function;
  lastCaseViewed?: number;
  queue: QueueEnum;
};

const CasesTableView = ({
  headerGroups,
  rows,
  prepareRow,
  lastCaseViewed,
  queue,
}: CasesTableViewProps) => {
  return (
    <Table
      headerGroups={headerGroups.map((headerGroup, index) => (
        <tr {...headerGroup.getHeaderGroupProps()} key={index}>
          {headerGroup.headers.map((column: HeaderGroup) => (
            <th
              {...column.getHeaderProps(column.getSortByToggleProps())}
              className="Headers__cell"
              onClick={() => {
                if (column.disableSortBy) return;
                column.isSorted
                  ? column.toggleSortBy(!column.isSortedDesc)
                  : column.toggleSortBy(
                      getDefaultCaseListSortDirection(queue) ===
                        CaseListDirection.Desc
                    );
              }}
              key={`column:${column.id}`}
            >
              {column.render("Header")}
              <span>
                {column.isSorted ? (
                  column.isSortedDesc ? (
                    <FontAwesomeIcon icon="angle-down" />
                  ) : (
                    <FontAwesomeIcon icon="angle-up" />
                  )
                ) : (
                  ""
                )}
              </span>
            </th>
          ))}
        </tr>
      ))}
      rows={rows.map((row) => {
        prepareRow(row);
        return (
          <Fragment
            {...row.getToggleRowExpandedProps}
            key={`case:${row.original.id}`}
          >
            <TableRow
              row={row}
              isLastCaseViewed={row.original.id === lastCaseViewed}
            />
          </Fragment>
        );
      })}
    />
  );
};

export default CasesTableView;
